import { ICommand } from 'core-ts-types';
import * as _4 from 'lodash4';
import { StudyGroupModalService } from '../../modals/study_groups_modal_service';
import { StudyGroupsPriorityFeedQuery } from '../../queries/study_groups_priority_feed_query';
import { StudyGroupsQuery } from '../../queries/study_groups_query';

export class StudyGroupsController {
  private isLoading: boolean = true;
  private isNotificationEnabled: boolean = false;

  constructor(
    private ngStudyGroupsQuery: StudyGroupsQuery,
    private loadStudyGroupsCommand: ICommand,
    private ngStudyGroupModalService: StudyGroupModalService,
    private $state: ng.ui.IStateService,
    private dismissStudyBuddyTileCommand: ICommand,
    private ngStudyGroupsPriorityFeedQuery: StudyGroupsPriorityFeedQuery,
    private appConfigModel: any
  ) {
    this.loadStudyGroupsCommand().then(() => {
      this.isLoading = false;
      if (this.ngStudyGroupsQuery.result.hasNotParticipated) {
        this.showDescriptionModal();
      }
      this.dismissPriorityFeedNotification();
    });
    this.isNotificationEnabled = this.appConfigModel.isFeatureEnabled('notification-settings');
  }

  dismissPriorityFeedNotification() {
    if (this.ngStudyGroupsPriorityFeedQuery.hasFeedNotification) {
      this.dismissStudyBuddyTileCommand();
    }
  }

  showDescriptionModal(): void {
    this.ngStudyGroupModalService.showDescriptionModal();
  }
  hideDescriptionModal(): void {
    this.ngStudyGroupModalService.hideDescriptionModal();
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-study-groups/src/views/study_groups/study_groups_controller.ts